import main20231111 from "@/pages/double11/2023/main.vue";
import xingji20231111 from "@/pages/double11/2023/xingji.vue";
import lizeng20231111 from "@/pages/double11/2023/lizeng.vue";
import butie20231111 from "@/pages/double11/2023/butie.vue";
import goodsForEmployee from "@/pages/GoodsForEmployee.vue"

const activityRouters = [
    {
        path: '/double11/2023/main',
        name: 'main20231111',
        component: main20231111,
    },
    {
        path: '/double11/2023/xingji',
        name: 'xingji20231111',
        component: xingji20231111,
    },
    {
        path: '/double11/2023/lizeng',
        name: 'lizeng20231111',
        component: lizeng20231111,
    },
    {
        path: '/double11/2023/butie',
        name: 'butie20231111',
        component: butie20231111,
    }, {
        path: '/double11/2023/goodsForEmployee',
        name: 'goodsForEmployee',
        component: goodsForEmployee
    }

]


export default activityRouters;
